import * as React from 'react';
import * as l10n from 'diy/util/l10n';
import {colors} from 'material-ui/styles';
import diyLightRawTheme from 'diy/material-ui/diyLightRawTheme';
import {InfoBox} from 'diy/custom-components/InfoBox';

import WarnIcon from "material-ui/svg-icons/alert/warning";

export enum Mode {
    None,
    Critical,
    Maximum
}

interface LimitationsProps {
    mode: Mode;
}

export class Limitations extends React.Component<LimitationsProps, {}> {

    render() {
        let limitationsMsg = '';
        if (this.props.mode === Mode.Maximum) {
            limitationsMsg = l10n.getString('limitations.maxAmountModulesPerPage');
        } else if (this.props.mode === Mode.Critical) {
            limitationsMsg = l10n.getString('limitations.warningAmountModulesPerPage');
        }

        let warnColor = this.props.mode === Mode.Critical ?
            diyLightRawTheme.palette.textColor :
            "#fff";

        return ( this.props.mode === Mode.None ? null :
            <InfoBox
                Icon={WarnIcon}
                iconColor={warnColor}
                paperCssClass={this.getCssClass()}
                paperStyles={this.getStyles()}
            >
                <div dangerouslySetInnerHTML={{__html: limitationsMsg}}></div>
            </InfoBox>
        );
    }

    private getStyles() {
        let topboxError = {
            backgroundColor: '#F7482D',
            color: '#FFF'
        };
        let topboxWarn = {
            backgroundColor: colors.orange50,
            opacity: 0.54
        };
        let topboxColors = this.props.mode === Mode.Maximum ? topboxError : topboxWarn;

        return topboxColors;
    }

    private getCssClass() {
        return this.props.mode === Mode.Maximum ? 'limitations-maximum' : 'limitations-critical';
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/components/Limitations.tsx
 **/